<template>
  <div class="article-card" @click="navigate" style="cursor:pointer;">
    <section class="image--section">
      <a>
        <img :src="item.img" class="main-image" alt=""/>
        <div class="arrow">
          <Icon href="arrow-right" size="42" fill="#000"/>
        </div>
      </a>
    </section>

    <Badge :text="item.badge" class="mt-24 mb-16"/>

    <h2 class="body-mobile-l--medium heading-s--medium mb-24 line-height-mobile-32 line-height-42">
      {{ item.title }}
    </h2>

    <div v-if="item.author && item.author.name">
      <ul class="d-flex align-center navigation">
        <li>
          <ul class="d-flex align-center">
            <li class="w-24 h-24"><img :src="item.author.image" :alt="item.author.name"/></li>
            <li class="caption-m--regular ml-8 text-black">{{ item.author.name }}</li>
          </ul>
        </li>
        <li v-if="item.created_at" class="dot"></li>
        <li v-if="item.created_at">
          <p class="caption-m--regular created-date">{{ item.created_at }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Badge from "@/components/Badge";
import Icon from "@/components/Icon";

export default {
  name: 'ArticleCard',
  components: { Icon, Badge },
  props: {
    item: { type: Object, required: true }
  },
  methods: {
    navigate() {
      if (this.item.href) {
        if (this.item.href.startsWith('/') && !this.item.href.includes('.html')) {
          this.$router.push(this.item.href);
        } else {
          window.location.href = this.item.href;
        }
      } else {
        this.$router.push({ name: 'Publication' });
      }
    }
  }
}
</script>

<style scoped>
/* Issue #5 — bring card titles down a notch to match the design.
   They were reading as full headings; cards want a tighter caption size. */
.article-card h2 {
  font-size: 22px;
  line-height: 1.3;
  letter-spacing: -0.005em;
}
@media (max-width: 1024px) {
  .article-card h2 {
    font-size: 20px;
    line-height: 1.3;
  }
}
</style>
